export default [
    // packages ordered by priority
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFTTNL",
    "PFPTT",
    "PFPTTF",
    "PFPTTNL",
    "PFTTF",
    "PFP",
    "PF",
    "HS",
];
